import './ui-loading.scss';
<template>
  {{#if @isLoading}}
    <section
      class="component-ui-loading"
      role="dialog"
      aria-busy="true"
      aria-live="polite"
      data-test-ui-loading
      ...attributes
    >
      <div class="_background">
      </div>
      <div class="_ellipse">
        <img src="/assets/images/loading-animation-2025.gif" alt="Loading..." />
      </div>
    </section>
  {{/if}}
</template>
